// 骨骼父子关系映射
export const boneParentMap: Record<string, string | null> = {
  root: null,
  background: "root",
  body: "root",
  body_base: "body",
  tail: "body",
  body_accessory: "body",
  hand_accessory: "body",
  left_arm: "body",
  left_hand: "left_arm",
  left_hand_accessory: "left_hand",
  left_sleeve: "left_arm",
  right_arm: "body",
  right_hand: "right_arm",
  right_hand_accessory: "right_hand",
  right_sleeve: "right_arm",
  leg_accessory: "body",
  head: "body",
  hair: "body",
  hair_full: "hair",
  hair_front: "hair",
  hair_back: "hair",
  hair_side: "hair",
  hair_accessory: "hair",
  face: "body",
  face_full: "face",
  face_accessory: "face",
  eye: "face",
  left_eye: "face",
  right_eye: "face",
  nose: "face",
  mouth: "face",
  beard: "face",
  left_ear: "body",
  left_ear_accessory: "left_ear",
  right_ear: "body",
  right_ear_accessory: "right_ear",
  head_accessory: "body",
  neck_accessory: "head",
  torso: "body",
  clothing_set: "torso",
  pants: "torso",
  jacket: "torso",
  clothing_base: "torso",
  clothing_decoration: "torso",
  torso_accessory: "torso",
  foreground: "root",
  other: null,
  nail_art: null,
  bag: null,
  gemoji: null,
  cake: null,
  eyebrow: "face",
};
